import * as React from 'react';
import { Tooltip } from 'src/component/Global/Tooltip';

class ReusableDiv {

    static checkoutStepTitle = (title) => (
        <div className="checkout-titles d-flex justify-content-between">
            <h2>{title}</h2>
        </div>
    );

    static PopupTitle = (title) => (
        <div className="modal-header border-0">
            <h3 className="modal-title m-auto" id="exampleModalLabel">{title}</h3>
        </div>
    );

    static dataSheetTooltip = () => (
        <Tooltip position={'right center'}
            opener={() => (
                <span className="lifecycle low-risk lifecycle-not-available"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-html="true"
                    data-title="Datasheet not available.">
                    <span>--</span>
                </span>
            )}
            content={() => (
                <>
                    Datasheet not available.
                </>
            )}
        />
    );

    static newsLetterAd = () => (
        <>
            <div className='m-b-20' id="espotImg">
            </div>
            <div className='newsletter m-b-20'>
                <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
                <p className='m-b-15 text-black'>Subscribe for online delivery</p>
                <a className='bs5 btn btn-primary w135'>Sign up now</a>
            </div>
        </>
    );
}

export default ReusableDiv;